export const setSessionValue = (key, value) => global.sessionStorage ? global.sessionStorage.setItem(key, value) : null
export const getSessionValue = key => global.sessionStorage ? global.sessionStorage.getItem(key) : null
